import dropdowncss from "../css/dropdown.module.css";
import commoncss from "../css/common.module.css";
import { useEffect, useState, useRef } from "react";
import { ReactComponent as DownArrowIcon } from "../assets/icons/down_arrow.svg";
import { ReactComponent as UpArrowIcon } from "../assets/icons/up_arrow.svg";
import { ReqFieldLabel } from "../../myfin_v2/components/mis";

// export default function Dropdown({
//   req=false,
//   class_="",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);

//   // Automatically select the option if there's only one
//   useEffect(() => {
//     if (options.length === 1) {
//       const singleOption = options[0];
//       setSelectedOptionLabel(singleOption.label);
//       onSelect && onSelect({ label: singleOption.label, value: singleOption.value });
//     } else if (selected && selected.label) {
//       setSelectedOptionLabel(selected.label);
//     }
//   }, [options, selected, onSelect]);

//   const handleSelect = (option) => {
//     onSelect && onSelect({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     // <div className={`${dropdowncss.dropdown_wrapper} ${commoncss.w60pct}`}>
//       <div className={`${dropdowncss.dropdown_wrapper} ${class_}`}>
//       {label && <span className={dropdowncss.dropdown_label}> {req&&(<ReqFieldLabel/>)}&nbsp; {label}</span>}
//       <div className={`${dropdowncss.dropdown} ${class_}`} onClick={() => setOpen(!open)}>
//         <div
//           className={`${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//         >
//           {selectedOptionLabel || placeHolder}
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>
//         <div
//           className={`${dropdowncss.dropdown_menu} ${open ? dropdowncss.open : ""}`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }

export default function Dropdown({
  req = false,
  class_ = "",
  class2_ = "",
  label,
  options = [],
  onSelect,
  placeHolder,
  selected,
  selValue = null, // New prop
  style2 = {}, // New prop for inline styles
  disableAutoSelect = false, // Added prop to prevent auto-trigger
  onOpenStateChange, // Added prop
  searchable = false, // Added prop
  wrapText = false, // Added prop for specific modals
  value, // Added support for value prop
}) {
  const activeSelected = selected !== undefined ? selected : value;
  const [open, setOpen] = useState(false);
  const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const menuRef = useRef(null);
  const lastMousePos = useRef({ x: 0, y: 0 });
  const isMouseDownInside = useRef(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(-1);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    const handleMouseUp = () => {
      isMouseDownInside.current = false;
    };
    document.addEventListener("mouseup", handleMouseUp);
    return () => {
      document.removeEventListener("mouseup", handleMouseUp);
    };
  }, []);

  const isLedgerField = String(placeHolder || "").toLowerCase().includes("ledger name") ||
                       String(placeHolder || "").toLowerCase() === "select name" ||
                       String(label || "").toLowerCase().includes("ledger name") ||
                       String(placeHolder || "").toLowerCase().includes("ledger code") ||
                       String(placeHolder || "").toLowerCase() === "select code" ||
                       String(label || "").toLowerCase().includes("ledger code");
  const actualSearchable = searchable || isLedgerField;
  const cleanOptions = (options || []).filter((opt) => {
    if (!opt) return false;
    const lbl = typeof opt === "object" ? opt.label : opt;
    return lbl !== undefined && lbl !== null && String(lbl).trim() !== "";
  });

  const filteredOptions = actualSearchable && searchTerm
    ? cleanOptions.filter((opt) => {
        const lbl = typeof opt === "object" ? (opt.label !== undefined ? opt.label : "") : opt;
        return String(lbl || "")
          .toLowerCase()
          .includes(searchTerm.toLowerCase());
      })
    : cleanOptions;

  useEffect(() => {
    if (document.activeElement !== inputRef.current) {
      setInputValue(selectedOptionLabel || "");
    }
  }, [selectedOptionLabel]);

  useEffect(() => {
    if (onOpenStateChange) {
      onOpenStateChange(open);
    }
  }, [open, onOpenStateChange]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
        setSearchTerm("");
        setInputValue(selectedOptionLabel || "");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOptionLabel]);

  useEffect(() => {
    let labelToSet = null;

    if (options.length === 1) {
      labelToSet = options[0].label;
      if (selectedOptionLabel !== labelToSet) {
        setSelectedOptionLabel(labelToSet);
        if (!disableAutoSelect) {
          onSelect &&
            onSelect({ label: options[0].label, value: options[0].value });
        }
      }
    } else if (selValue !== undefined && selValue !== null && selValue !== "") {
      const matchedOption = options.find(
        (opt) => {
          try {
            const optVal = JSON.parse(opt.value);
            const selVal = JSON.parse(selValue);
            if (optVal && selVal && optVal.notes_grp && selVal.notes_grp) {
              return optVal.notes_grp.toLowerCase() === selVal.notes_grp.toLowerCase();
            }
          } catch (e) {
            // ignore JSON parse errors
          }
          return String(opt.value).toLowerCase() === String(selValue).toLowerCase();
        }
      );
      if (matchedOption) {
        if (selectedOptionLabel !== matchedOption.label) {
          setSelectedOptionLabel(matchedOption.label);
          if (!disableAutoSelect) {
            onSelect &&
              onSelect({ label: matchedOption.label, value: matchedOption.value });
          }
        }
      } else {
        // Fallback: Use selValue directly if options is empty or not matching
        let displayLabel = String(selValue);
        try {
           const parsed = JSON.parse(selValue);
           if (parsed && typeof parsed.notes_grp === "string") {
             displayLabel = parsed.notes_grp;
           }
        } catch(e) {}
        
        if (displayLabel === "") {
          displayLabel = null;
        }

        if (selectedOptionLabel !== displayLabel) {
           setSelectedOptionLabel(displayLabel);
        }
      }
    } else if (activeSelected) {
      const labelVal = typeof activeSelected === "string" ? activeSelected : activeSelected.label;
      if (labelVal) {
        if (labelVal !== selectedOptionLabel) {
          setSelectedOptionLabel(labelVal);
        }
      } else {
        if (selectedOptionLabel !== null) {
          setSelectedOptionLabel(null);
        }
      }
    } else if (activeSelected === "" || activeSelected === null) {
      // Only reset if the parent explicitly passes an empty/null value (controlled reset)
      if (selectedOptionLabel !== null) {
        setSelectedOptionLabel(null);
      }
    }
    // If activeSelected is undefined (uncontrolled), leave selectedOptionLabel as-is
    // so manual user selections are preserved.
  }, [options, activeSelected, selValue, onSelect, selectedOptionLabel, disableAutoSelect]);

  const handleSelect = (option) => {
    if (!option) return;
    const label = option.label !== undefined ? option.label : option;
    const val = option.value !== undefined ? option.value : option;
    onSelect && onSelect({ label: label, value: val });
    setSelectedOptionLabel(label);
    setInputValue(label || "");
    setSearchTerm("");
    setHighlightedIndex(-1);
    setOpen(false);
  };

  const handleMouseMove = (e, index) => {
    if (e.clientX !== lastMousePos.current.x || e.clientY !== lastMousePos.current.y) {
      lastMousePos.current = { x: e.clientX, y: e.clientY };
      setHighlightedIndex(index);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Tab") return;

    if (actualSearchable && document.activeElement === inputRef.current) {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        if (!open) {
          setOpen(true);
          setHighlightedIndex(0);
        } else {
          setHighlightedIndex((prev) => {
            if (prev < 0) return 0;
            const nextIndex = prev + 1;
            return nextIndex < filteredOptions.length ? nextIndex : 0;
          });
        }
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        if (!open) {
          setOpen(true);
          setHighlightedIndex(filteredOptions.length - 1);
        } else {
          setHighlightedIndex((prev) => {
            if (prev <= 0) return filteredOptions.length - 1;
            return prev - 1;
          });
        }
      } else if (e.key === "Enter") {
        e.preventDefault();
        if (open) {
          if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
            handleSelect(filteredOptions[highlightedIndex]);
          } else if (filteredOptions.length > 0) {
            handleSelect(filteredOptions[0]);
          }
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        setOpen(false);
        setSearchTerm("");
        setInputValue(selectedOptionLabel || "");
      }
      return;
    }

    if (!open) {
      if (e.key === "ArrowDown" || e.key === "ArrowUp" || e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setOpen(true);
        setHighlightedIndex(0);
      }
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setHighlightedIndex((prev) => {
        if (prev < 0) return 0;
        const nextIndex = prev + 1;
        return nextIndex < filteredOptions.length ? nextIndex : 0;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setHighlightedIndex((prev) => {
        if (prev <= 0) return filteredOptions.length - 1;
        return prev - 1;
      });
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (highlightedIndex >= 0 && highlightedIndex < filteredOptions.length) {
        handleSelect(filteredOptions[highlightedIndex]);
      } else if (filteredOptions.length > 0) {
        handleSelect(filteredOptions[0]);
      }
    } else if (e.key === "Escape") {
      e.preventDefault();
      setOpen(false);
      setSearchTerm("");
    }
  };

  useEffect(() => {
    if (open && actualSearchable && inputRef.current) {
      const timer = setTimeout(() => {
        inputRef.current?.focus();
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [open, actualSearchable]);

  useEffect(() => {
    setHighlightedIndex(-1);
  }, [searchTerm]);

  useEffect(() => {
    if (highlightedIndex >= 0 && menuRef.current) {
      const activeEl = menuRef.current.children[highlightedIndex];
      if (activeEl) {
        activeEl.scrollIntoView({
          block: "nearest",
        });
      }
    }
  }, [highlightedIndex]);

  return (
    <div
      ref={dropdownRef}
      className={`${dropdowncss.dropdown_wrapper} ${class_}`}
      onKeyDown={handleKeyDown}
      onMouseDown={() => {
        isMouseDownInside.current = true;
      }}
      tabIndex={0}
    >
      {label && (
        <span className={dropdowncss.dropdown_label}>
          {req && <ReqFieldLabel />} &nbsp; {label}
        </span>
      )}
      <div
        className={`${dropdowncss.dropdown} ${class_}`}
        onClick={() => setOpen(!open)}
      >
        <div
          className={`${class2_} ${dropdowncss.dropdown_selected} ${
            selectedOptionLabel ? dropdowncss.has_value : ""
          }`}
          style={style2}
          {...(!open && !actualSearchable && selectedOptionLabel && selectedOptionLabel.trim() !== ""
            ? { "data-tooltip": selectedOptionLabel }
            : {})}
        >
          {actualSearchable ? (
            <>
              <style>{`
                .dropdown_search_input::placeholder {
                  color: #b3c0bd !important;
                  opacity: 1 !important;
                }
              `}</style>
              <input
                ref={inputRef}
                type="text"
                className={`${dropdowncss.dropdown_selected_text} dropdown_search_input`}
                placeholder={placeHolder}
                value={inputValue}
                style={{
                  border: "none",
                  outline: "none",
                  background: "transparent",
                  width: "100%",
                  padding: 0,
                  margin: 0,
                  color: "#205a46",
                  fontSize: "inherit",
                  fontWeight: "inherit",
                  height: "18px",
                  lineHeight: "18px",
                }}
                onChange={(e) => {
                  const val = e.target.value;
                  setInputValue(val);
                  setSearchTerm(val);
                  setHighlightedIndex(-1);
                  setOpen(true);
                  if (val === "") {
                    setSelectedOptionLabel(null);
                    onSelect && onSelect({ label: "", value: "" });
                  }
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen(true);
                  setHighlightedIndex(-1);
                }}
                onBlur={(e) => {
                  if (dropdownRef.current && dropdownRef.current.contains(e.relatedTarget)) {
                    return;
                  }
                  if (isMouseDownInside.current) {
                    return;
                  }
                  if (inputValue === "") {
                    setSelectedOptionLabel(null);
                    setSearchTerm("");
                    onSelect && onSelect({ label: "", value: "" });
                  } else {
                    setInputValue(selectedOptionLabel || "");
                    setSearchTerm("");
                  }
                }}
              />
            </>
          ) : (
            <span className={dropdowncss.dropdown_selected_text}>
              {selectedOptionLabel || placeHolder}
            </span>
          )}
          <span className={dropdowncss.dropdown_arrow}>
            {open ? <UpArrowIcon /> : <DownArrowIcon />}
          </span>
        </div>

        <div
          ref={menuRef}
          className={`${dropdowncss.dropdown_menu} ${
            open ? dropdowncss.open : ""
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          {filteredOptions.map((opt, i) => {
            const optLabel = typeof opt === "object" ? opt.label : opt;
            const isActive = optLabel === selectedOptionLabel;
            const isHighlighted = highlightedIndex === i;
            
            const itemStyle = {
              backgroundColor: isHighlighted || isActive ? "#f4faf5" : undefined,
              fontWeight: isActive || isHighlighted ? "600" : "400",
              color: isActive || isHighlighted ? "#205a46" : undefined,
              fontSize: "13px",
              ...(wrapText
                ? {
                    display: "block",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                  }
                : {}),
            };

            return (
              <div
                key={i}
                className={`${dropdowncss.dropdown_item} ${
                  isActive ? dropdowncss.active : ""
                } ${isHighlighted ? dropdowncss.highlighted : ""}`}
                style={itemStyle}
                onMouseDown={(e) => {
                  // Prevent input blur before click fires so filtered list doesn't shift
                  e.preventDefault();
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelect(opt);
                }}
                onMouseMove={(e) => handleMouseMove(e, i)}
              >
                {optLabel}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// export default function Dropdown({
//   req = false,
//   class_ = "",
//   class2_ = "",
//   label,
//   options = [],
//   onSelect,
//   placeHolder,
//   selected = {},
//   selValue = null,
// }) {
//   const [open, setOpen] = useState(false);
//   const [selectedOptionLabel, setSelectedOptionLabel] = useState(null);
//   const dropdownRef = useRef(null);

//   // ================= CLICK OUTSIDE =================
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   // ================= SYNC SELECTION =================
//   useEffect(() => {
//     let matchedOption = null;

//     // Auto-select if only one option
//     if (options.length === 1) {
//       matchedOption = options[0];
//     }

//     // Match by selValue
//     else if (selValue != null) {
//       matchedOption = options.find(
//         (opt) =>
//           String(opt.value).toLowerCase() ===
//           String(selValue).toLowerCase()
//       );
//     }

//     // Match by selected.label
//     else if (selected?.label) {
//       matchedOption = options.find(
//         (opt) => opt.label === selected.label
//       );
//     }

//     // ✅ FOUND → SET
//     if (matchedOption) {
//       if (selectedOptionLabel !== matchedOption.label) {
//         setSelectedOptionLabel(matchedOption.label);
//         onSelect?.({
//           label: matchedOption.label,
//           value: matchedOption.value,
//         });
//       }
//     }

//     // ❌ NOT FOUND → RESET
//     else if (selectedOptionLabel !== null) {
//       setSelectedOptionLabel(null);
//       onSelect?.(null); // reset parent
//     }
//   }, [options, selected, selValue]);

//   // ================= MANUAL SELECT =================
//   const handleSelect = (option) => {
//     onSelect?.({ label: option.label, value: option.value });
//     setSelectedOptionLabel(option.label);
//     setOpen(false);
//   };

//   return (
//     <div
//       ref={dropdownRef}
//       className={`${dropdowncss.dropdown_wrapper} ${class_}`}
//     >
//       {label && (
//         <span className={dropdowncss.dropdown_label}>
//           {req && <ReqFieldLabel />} &nbsp; {label}
//         </span>
//       )}

//       <div
//         className={`${dropdowncss.dropdown} ${class_}`}
//         onClick={() => setOpen(!open)}
//       >
//         <div
//           className={`${class2_} ${dropdowncss.dropdown_selected} ${
//             selectedOptionLabel ? dropdowncss.has_value : ""
//           }`}
//           data-tooltip={selectedOptionLabel || ""}
//         >
//           <span className={dropdowncss.dropdown_selected_text}>
//             {selectedOptionLabel || placeHolder}
//           </span>
//           <span className={dropdowncss.dropdown_arrow}>
//             {open ? <UpArrowIcon /> : <DownArrowIcon />}
//           </span>
//         </div>

//         <div
//           className={`${dropdowncss.dropdown_menu} ${
//             open ? dropdowncss.open : ""
//           }`}
//         >
//           {options.map((opt, i) => (
//             <div
//               key={i}
//               className={dropdowncss.dropdown_item}
//               onClick={() => handleSelect(opt)}
//             >
//               {opt.label}
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// }
